export default __webpack_public_path__ + "static/media/failed.7735e89a.svg";